<table class="table">
  <thead>
    <tr *ngIf="!trackerOnlyColumns">
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.MasterBillNumber) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.MasterBillNumber) }" (click)="sort(columns.MasterBillNumber)">Master B/L #</button>
      </th>
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.HouseBillNumber) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.HouseBillNumber) }" (click)="sort(columns.HouseBillNumber)">House B/L #</button>
      </th>
      <th scope="col">
        Container #
      </th>
      <th scope="col">
        Order Ref #
      </th>
      <th scope="col">Shipment #</th>
      <th scope="col" *ngIf="!trackerOnlyColumns">Date Entered</th>
      <th scope="col" *ngIf="!trackerOnlyColumns">Sending Office</th>
      <th scope="col" *ngIf="isExtendedColumnsMode" [ngClass]="{ 'dropup': isSortedByColumn(columns.ETD) && isSortDirectionDesc() }"><button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ETD) }" (click)="sort(columns.ETD)">ETD</button></th>
      <th scope="col" *ngIf="isExtendedColumnsMode" [ngClass]="{ 'dropup': isSortedByColumn(columns.ETA) && isSortDirectionDesc() }"><button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ETA) }" (click)="sort(columns.ETA)">ETA</button></th>
      <th scope="col" *ngIf="(isExtendedColumnsMode && !trackerOnlyColumns)">Shipment Code</th>
      <th scope="col" *ngIf="isExtendedColumnsConsignee">Consignee</th>
      <th scope="col" *ngIf="trackerOnlyColumns">ATD</th>
      <th scope="col" *ngIf="trackerOnlyColumns">ATA</th>
      <th scope="col" *ngIf="trackerOnlyColumns">Delivered</th>
    </tr>
    <tr *ngIf="trackerOnlyColumns">
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.MasterBillNumber) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.MasterBillNumber) }" (click)="sort(columns.MasterBillNumber)">Master B/L #</button>
      </th>
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.HouseBillNumber) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.HouseBillNumber) }" (click)="sort(columns.HouseBillNumber)">House B/L #</button>
      </th>
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.Container) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.Container) }" (click)="sort(columns.Container)">
          Container #
        </button>
      </th>
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.OrderRefNumber) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.OrderRefNumber) }" (click)="sort(columns.OrderRefNumber)">
          Order Ref #
        </button>
      </th>
      <th scope="col" [ngClass]="{ 'dropup': isSortedByColumn(columns.ShipmentCode) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ShipmentCode) }" (click)="sort(columns.ShipmentCode)">Shipment #</button>
      </th>
      <th scope="col" *ngIf="!trackerOnlyColumns">Date Entered</th>
      <th scope="col" *ngIf="!trackerOnlyColumns">Sending Office</th>
      <th scope="col" *ngIf="isExtendedColumnsMode" [ngClass]="{ 'dropup': isSortedByColumn(columns.ETD) && isSortDirectionDesc() }"><button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ETD) }" (click)="sort(columns.ETD)">ETD</button></th>
      <th scope="col" *ngIf="isExtendedColumnsMode" [ngClass]="{ 'dropup': isSortedByColumn(columns.ETA) && isSortDirectionDesc() }"><button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ETA) }" (click)="sort(columns.ETA)">ETA</button></th>
      <th scope="col" *ngIf="(isExtendedColumnsMode && !trackerOnlyColumns)">Shipment Code</th>
      <th scope="col" *ngIf="isExtendedColumnsConsignee">Consignee</th>
      <th scope="col" *ngIf="trackerOnlyColumns" [ngClass]="{ 'dropup': isSortedByColumn(columns.ATD) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ATD) }" (click)="sort(columns.ATD)">ATD</button>
      </th>
      <th scope="col" *ngIf="trackerOnlyColumns" [ngClass]="{ 'dropup': isSortedByColumn(columns.ATA) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ATA) }" (click)="sort(columns.ATA)">ATA</button>
      </th>
      <th scope="col" *ngIf="trackerOnlyColumns" [ngClass]="{ 'dropup': isSortedByColumn(columns.ActualDelivery) && isSortDirectionDesc() }">
        <button class="btn btn-link" [ngClass]="{ 'dropdown-toggle': isSortedByColumn(columns.ActualDelivery) }" (click)="sort(columns.ActualDelivery)">Delivered</button>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let consol of consolList">
      <tr>
        <td>
          <a *ngIf="routerlinkPathFn" [routerLink]="[routerlinkPathFn(consol)]">{{ consol.MasterBill }}</a>
          <span *ngIf="!routerlinkPathFn">{{ consol.MasterBill }}</span>
        </td>
        <td>{{ consol.HouseBill }}</td>
        <td>
          <button class="btn btn-link" *ngIf="isRowExpandable(consol.Containers) && !isRowExpanded(consol.MasterBill + consol.HouseBill)" (click)="expandRow(consol.MasterBill + consol.HouseBill)">Multiple - View All</button>
          <button class="btn btn-link" *ngIf="isRowExpandable(consol.Containers) && isRowExpanded(consol.MasterBill + consol.HouseBill)" (click)="collapseRow(consol.MasterBill + consol.HouseBill)">Multiple - Collapse</button>
          <span *ngIf="!isRowExpandable(consol.Containers)">{{ consol.Containers[0] }}</span>
        </td>
        <td>
          <button class="btn btn-link" *ngIf="isRowExpandable(consol.OrderRefs) && !isRowExpanded(consol.MasterBill + consol.HouseBill)" (click)="expandRow(consol.MasterBill + consol.HouseBill)">Multiple - View All</button>
          <button class="btn btn-link" *ngIf="isRowExpandable(consol.OrderRefs) && isRowExpanded(consol.MasterBill + consol.HouseBill)" (click)="collapseRow(consol.MasterBill + consol.HouseBill)">Multiple - Collapse</button>
          <span *ngIf="!isRowExpandable(consol.OrderRefs)">{{ consol.OrderRefs[0] }}</span>
        </td>
        <td>{{ consol.ShipmentCode }}</td>
        <td *ngIf="!trackerOnlyColumns">{{ consol.DateEntered | absoluteDate }}</td>
        <td *ngIf="!trackerOnlyColumns">{{ consol.SendingOffice }}</td>
        <td *ngIf="isExtendedColumnsMode">{{ consol.ETD | absoluteDate }}</td>
        <td *ngIf="isExtendedColumnsMode">{{ consol.ETA | absoluteDate }}</td>
        <td *ngIf="(isExtendedColumnsMode && !trackerOnlyColumns)">{{ consol.ShipmentCode }}</td>
        <td *ngIf="isExtendedColumnsConsignee">{{ consol.ConsigneeName }}</td>
        <td *ngIf="trackerOnlyColumns">{{ consol.ATD | absoluteDate }}</td>
        <td *ngIf="trackerOnlyColumns">{{ consol.ATA | absoluteDate }}</td>
        <td *ngIf="trackerOnlyColumns">{{ consol.ActualDelivery | absoluteDate }}</td>
      </tr>
      <tr *ngIf="isRowExpanded(consol.MasterBill + consol.HouseBill)">
        <td></td>
        <td class="font-weight-bold">Container #'s</td>
        <td>
          <div *ngFor="let containerNumber of consol.Containers">{{ containerNumber }}</div>
        </td>
        <td>
          <div *ngFor="let orderRefNumber of consol.OrderRefs">{{ orderRefNumber }}</div>
        </td>
        <td *ngIf="!trackerOnlyColumns"></td>
        <td *ngIf="!trackerOnlyColumns"></td>
        <td *ngIf="isExtendedColumnsMode"></td>
        <td *ngIf="isExtendedColumnsMode"></td>
        <td *ngIf="(isExtendedColumnsMode && !trackerOnlyColumns)"></td>
        <td *ngIf="isExtendedColumnsConsignee"></td>
        <td *ngIf="trackerOnlyColumns"></td>
        <td *ngIf="trackerOnlyColumns"></td>
        <td *ngIf="trackerOnlyColumns"></td>
      </tr>
    </ng-container>
  </tbody>
  <tr *ngIf="!consolList.length">
    <td [attr.colspan]="isExtendedColumnsMode ? 10 : 8" class="p-5">
      <div class="d-flex font-weight-bold justify-content-center align-items-center">
        <!--Your search yielded no results. Please <button class="btn btn-link p-1 font-weight-bold" (click)="clearFilters.emit()">clear filters</button> and try again.-->
        <!--Your search yielded no results. Please clear filters and try again.-->
        {{ NoResultMessage }}
      </div>
    </td>
  </tr>
</table>
